import { FC } from 'react';

import SavedSearchFromResults from 'src/components/SavedSearch/Vacancy/SavedSearchFromResults';
import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';
import { UserType } from 'src/models/userType';

const SavedSearchSubscription: FC = () => {
    const isSuitableVacancySearch = useSelector((state) => !!state.vacancySearchResult?.criteria?.resume);
    const userType = useSelector((state) => state.userType);
    const isEmployerOrBackOffice = userType === UserType.Employer || userType === UserType.BackOffice;

    if (isSuitableVacancySearch || isEmployerOrBackOffice) {
        return null;
    }

    return <SavedSearchFromResults />;
};

export default translation(SavedSearchSubscription);
